import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class AiTrackDayService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' });
    private baseUrl = 'api/aiTrackDay';

    constructor(private http: Http) {}

    private extractData(res: any) {
        return res.json() || [];
    }

    getList(query: any): Promise<any> {
        const params = new URLSearchParams();
        for (const key in query) { params.set(key, query[key]); }
        const options = new RequestOptions({ headers: this.headers, search: params });
        return this.http.get(`${this.baseUrl}/getList`, options)
            .toPromise().then(this.extractData).catch(this.handleError);
    }

    save(data: any): Promise<any> {
        return this.http.post(`${this.baseUrl}/save`, $.param(data), { headers: this.headers })
            .toPromise().then(res => res.json()).catch(this.handleError);
    }

    delete(track_day_id: any): Promise<any> {
        return this.http.post(`${this.baseUrl}/delete`, $.param({ track_day_id }), { headers: this.headers })
            .toPromise().then(res => res.json()).catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/aiTrackDay.service.ts